import _ from 'lodash'

import { IsRealDevice } from 'e-submission/utils'
import { getToggles } from 'quick-quote/feature-toggles'

import { eKycCheckDataInsured, eKycCheckDataPayer, getEkycValidationId, getPassport, isForeigner } from './selectors'
import { createSectionCreator, createField } from './utils'

const ekycFields = (insuredOrPayer) => (app, id) => {
  const validationEKYCInsured = eKycCheckDataInsured(insuredOrPayer, app)
  const validationEKYCPayer = eKycCheckDataPayer(insuredOrPayer, app)
  const isRequiredEkycValidation =
    insuredOrPayer === 'payer' ? validationEKYCPayer.isRequiredPayer : validationEKYCInsured.isRequiredInsured
  const validationId = getEkycValidationId(insuredOrPayer, isRequiredEkycValidation)
  return [
    createField(
      `${insuredOrPayer}.${id}`,
      _.compact([
        {
          id: `${insuredOrPayer}.${id}`,
          c: 'ekycDocument',
          p: {
            insuredOrPayer,
          },
        },
        {
          id: validationId,
          c: 'NumberInput',
          required: isRequiredEkycValidation,
          p: {
            hidden: true,
          },
        },
      ])
    ),
  ]
}

const ekycFooter = (insuredOrPayer) => (app, id) => {
  const isForeignerPayer = isForeigner(app, 'payer')
  const isForeignerInsured = isForeigner(app, 'insured')
  const insuredPassport = getPassport('insured')(app)
  const payerPassport = getPassport('payer')(app)
  const isForeignerInsuredWithoutPassport =
    isForeignerInsured && !_.isEmpty(insuredPassport) && insuredPassport.length === 13
  const isForeignerPayerWithoutPassport = isForeignerPayer && !_.isEmpty(payerPassport) && payerPassport.length === 13

  const haveForeignerWithoutPassport =
    (isForeignerInsuredWithoutPassport ?? false) || (isForeignerPayerWithoutPassport ?? false)

  return [
    createField(
      `${insuredOrPayer}.${id}`,
      _.compact([
        {
          id: `${insuredOrPayer}.${id}`,
          c: 'ekycDocumentFooter',
          p: {
            insuredOrPayer,
          },
        },
      ])
    ),
    haveForeignerWithoutPassport &&
      createField('tamloInfoMessage', [
        {
          id: 'tamloInfoMessage',
          required: false,
          c: 'InfoMessage',
          p: {
            mergeState: () => ({
              value: 'เนื่องจากระบุหมายเลขหนังสือเดินทางไม่ถูกต้อง ทางบริษัทขอสงวนสิทธิ์ในการขายผ่าน Remote selling',
            }),
          },
        },
      ]),
  ]
}

export const ekycOnDevice = (app, id) => {
  const isOnDeviceId = 'ekycInfo.isOnDevice'
  const selectedRemoteSellingId = 'selectedRemoteSelling'
  const isAllowedRevisedRemoteSelling = getToggles().ENABLE_APPMAN_REMOTE_SELLING //!TODO Mock from MW
  if (isAllowedRevisedRemoteSelling) {
    return _.compact([
      createField(selectedRemoteSellingId, [
        {
          id: selectedRemoteSellingId,
          c: 'ekycSellingChannel',
        },
      ]),
    ])
  } else if (IsRealDevice) {
    return [
      createField(isOnDeviceId, [
        {
          id: isOnDeviceId,
          c: 'RadioGroup',
          required: true,
          p: {
            options: [
              {
                text: 'ยืนยันตัวตน (eKYC) ผ่านระบบ AdvisorZone',
                value: true,
              },
              {
                text: 'ยืนยันตัวตน (eKYC) ด้วยตนเองผ่าน SMS หรือ email',
                value: false,
              },
            ],
          },
        },
      ]),
    ]
  }

  return [createField(isOnDeviceId, [])]
}

export const insuredEkycSection = createSectionCreator(ekycFields('insured'))
export const payerEkycSection = createSectionCreator(ekycFields('payer'))
export const ekycSectionFooter = createSectionCreator(ekycFooter('payer'))
export const ekycOnDeviceSection = createSectionCreator(ekycOnDevice)
